
import {  Link } from "react-router-dom"
import SelectList from 'react-widgets/lib/SelectList'

/*
import asyncValidate from './asyncValidate'
import {flyLoadAddressData as loadFlyAddressDataDB } from '../../redux/svractions/svflyreviewActions'

import {loadAddressDataDB as loadAccount } from '../../redux/svractions/svreviewActions'
*/
import {flyLoadAddressData as loadFlyAddressDataDB } from '../../redux/svractions_cosmos/svflyreviewActions_cosmos'

import { reduxForm , handleSubmit, FieldArray,Field, startSubmit, formValueSelector} from 'redux-form'

//import { loadPdAction, loadPdMyReservatiionsAddressAction} from '../../actions'
import {SVFPDFORM,SV_SERVICES, SV_SERVER_ADDRESS, SV_URL} from '../../constants'
import {SV_SOJ_ORCMOCK_ADDRESS} from '../../constants'
import { Radio } from 'antd'
import {SVPDDInputEp} from '../core/svpddinputEp'
import { DatePicker } from 'antd';
import {  Button as SVAButton } from 'antd';


import moment from 'moment'
import '../../css/svformwerror.css'

///Users/sam_b2/Downloads/tm/svctest/frontend-quiz/app/css/svdreact.css
//import '../../css/svdreact.css'
const React = require('react')
const _ = require('lodash')
const {connect}  = require("react-redux")


const svChange = (values, dispatch, props, valuesPrev)=>{

    console.log('sv form change')
  
    console.log(values)
  
  
  }

const isdcodeTypesOrg = [{
    name:'United States Of America(+1)',
    value:'+1'
  },{
    name:'Australia(+61)',
    value:'61'
},{
    name:'Spain(+34)',
    value:'34'
  }]
const countryTypesOrg = [{
    name:'United States Of America',
    value:'USA'
  },{
    name:'Australia',
    value:'AUS'
},{
    name:'Spain',
    value:'ES'
  
  }]
const genderTypesOrg = [{
    name:'CL_MALE',
    value:'MALE'
  },{
    name:'CL_FEMALE',
    value:'FEMALE'
  
  }]

const svNotifySavePromise=(
    values
)=>{
            let url= `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
            let data = {
                "id": "addLeft_step"

            }
            data = values
            //data =transformToBA(values)
            let postRq={
                method:'POST',
                headers:{
                    Accept:'application/json',
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(data) 
            }


            return fetch(url, postRq).then((rs)=>{
                console.log('sv got rs promise')
                return rs.json()
            }).catch((e)=>{
                return new Promise.resolve(e)
            })
}

const svsubmit =(values)=>{
    let me = this
  console.log('sv submit callback')
  console.log(values)
/*

  Promise.all([svNotifySavePromise(values)]).then((ar)=>{
      console.log('sv got promise data')

      let rs= ar[0]
      console.log(rs)
        if(rs.data.value.payload.gene){
           // me.props.geneReceptorActivate(rs.data.value.payload.gene, rs.data.value.payload)
        }
   

  })
  */
  //this.props.handleSubmit(this.props.submit('SVClassifierForm'))
}

const renderField = ({
    input,
    label,
    type,
    meta: { asyncValidating, touched, error }
  }) => (
    
     
      
      <div className={asyncValidating ? 'async-validating' : ''}>
          
        <input className="form-control" {...input} type={type} placeholder={label} />
        {touched && error && <span className="sv-form-err" >{error}</span>}
      </div>
   
  )
  const renderFieldDup = ({
    input,
    label,
    type,
    meta: { asyncValidating, touched, error }
  }) => (
    
     
      
      <div className={asyncValidating ? 'async-validating' : ''}>
          {touched && error &&  <input className="sverr form-control" {...input} type={type} placeholder={label} /> }
          {touched && !error &&  <input className="svgreen form-control" {...input} type={type} placeholder={label} /> }
        <input className="form-control" {...input} type={type} placeholder={label} />
        {touched && error && <span className="sv-form-err" >{error}</span>}
      </div>
   
  )
const renderSelectList = ({ input, data }) => (
    <SelectList {...input} onBlur={() => input.onBlur()} data={data} />
  )
  const renderTravelSelectList = ({ input, data }) => (
    <SelectList {...input} onBlur={() => input.onBlur()} data={data} />
  )

  const renderGenderSelectList = ({ input, data }) => (
    <SelectList {...input} onBlur={() => input.onBlur()} data={data} />
  )

  const renderBookingAgentType = ({input, data})=> (
      <SelectList {...input } onBlur={() =>input.onBlur()} data={data} />
  )
let dcountries = [{
    name:'United States Of America',
    value:'usa'

  },{
    name:'France',
    value:'France'
  },{

    name:'China',
    value:'China'
},{
    name:'Mexico',
    value:'Mexico'
  
  }]

let genes = [{
    name:'add_step',
    value:'add_step'

  },{
    name:'multiply_seq_step',
    value:'multiply_seq_step'
  },{

    name:'sq_step',
    value:'sq_step'
},{
    name:'sr_step',
    value:'sr_step'
  
  }]

  
  let validate =(formData)=>{
    console.log('sv--valudare fprmData')
      console.log(validate)
        const errors={}
        if(!formData){
            console.log('validate: sv formData null issue')
            console.log(errors)
            return errors
        }
        if(!formData.fname){
            errors.fname= 'Required'
        }
        if(!formData.lname){
            errors.lname= 'Required'
        }
        if(!formData.email){
            errors.email= 'Required'
        }
        if(!formData.address){
            errors.address= 'Required'
        }
        if(!formData.city){
            errors.city= 'Required'
        }
        if(!formData.zip){
            errors.zip= 'Required'
        }
        /*
        if(!formData.dateOfBirth){
            errors.dateOfBirth= 'Required'
        }
        */
        if(!formData.gender){
            errors.gender= 'Required'
        }
       
        if(!formData.country){
            errors.country= 'Required'
        }
        if(!formData.phone){
            errors.phone= 'Required'
        }
        
        /*sva
        if(!formData.card){
            errors.card= 'Required'
        }
        if(!formData.cvv){
            errors.cvv= 'Required'
        }
        if(!formData.mmexp){
            errors.mmexp= 'Required'
        }
        if(!formData.yyyyexp){
            errors.yyyyexp= 'Required'
        }
        if(!formData.country){
            errors.country= 'Required'
        }
        */
       console.log('FlyPaymentDEtailFormBusCom validate error *************')
        console.log(errors)
        return errors
    
    }
    
    let warn= (formData)=>{
        const o = {}
        if(!formData){
            console.log('sv gene null issue')
            return o
        }
        /*
        if(formData.lname <2){
            o.gene ='We expect gene to br more tham 5'
        }
        */
        return o
    }

    const data = {
        "id": 6,
        "dateOfBirth": "1982-01-15",
        "gender": "MALE",

        "addressId": 6,
        "customerId": 6,
        "name": "alen beta",
        "fname": "alenHwForm",
        "lname": "betaHwForm",
        "phone": "5121231234",
        "email": "alenHwFomr@HwForm.com",
        "login": "alenbHwForm",
        "password": null,
        "otherDetails": "need pickup",
        "city": "san joseHwForm",
        "state": "ca",
        "country": "usa",
        "address": null,
        "zip": "95123",
        "isdcode": "3",
        "addressType": "B",
        "createdDate": null,
        "modifiedDate": null,
        "createdBy": null,
        "modifiedBy": null
    }

class FlyPaymentDetailFormBus extends React.Component{
    

    constructor(props){
        super(props)
        let me = this
        this.svpdcCurryCom = this.svpdcCurryCom.bind(me)
        this.renderAd = this.renderAd.bind(me)
      
       
        this.loadGene = this.loadGene.bind(this)
        this.ddChange = this.ddChange.bind(this) 
        this.fsHome = this.fsHome.bind(this)
        /*
        this.getAppDetails = this.getAppDetails.bind(this)
        */
        this.dcountryChange = this.dcountryChange.bind(this)
    }
    
fsHome(custProfile){
    if(custProfile && (custProfile.customerId > 0) ){
        let myroute = `/myaccountSV/${custProfile.customerId}/mysvflyspaceSearch`
        return (
        
            <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#e91b1b'}} type="primary" shape="round"  size="{size}" ><Link to={myroute}> Flights Home   </Link></SVAButton>

       )
    }else{
        return (
        
            <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#e91b1b'}} type="primary" shape="round"  size="{size}" ><Link to={`/svlogin`}> My Reservations   </Link></SVAButton>

       )
    }
   
}

    componentWillMount()	{
        console.log('sv--call PaymentData  should needs addressid action load to gtethe formvalues fpdForm')
        const { custProfile, my_data_flyaddress, my_data_card} = this.props
         console.log('sv***--Oct7 load Step1  PaymentDetail  PaymentData custProfile  from SVWizard+')
      
        console.log(custProfile)
        console.log(my_data_flyaddress)
         console.log('sv***-- load Step2 PaymentDetail dcustProfile from  SVWizrd end')
         if( my_data_flyaddress && (my_data_flyaddress.email.length > 0)){
            console.log('sv-- Oct7 load Step3  callinf this.props.load( PaymentDetail dcustProfile from  SVWizrd calls load ')
            console.log(my_data_flyaddress)
            this.props.load(my_data_flyaddress)
         }
         /*
         if( custProfile && (custProfile.customerId > 0)){
            this.props.load(custProfile)
         }
         */
         /*
        const data = {
            "addressId": 6,
            "customerId": 6,
            "name": "alen beta",
            "fname": "alen",
            "lname": "beta",
            "phone": "5121231234",
            "email": "alen11@br.com",
            "login": "alenb",
            "password": null,
            "otherDetails": "need pickup",
            "city": "san jose",
            "state": "ca",
            "country": "usa",
            "address": null,
            "zipcode": "95123",
            "isdcode": "1",
            "addressType": "B",
            "createdDate": null,
            "modifiedDate": null,
            "createdBy": null,
            "modifiedBy": null
        }
       this.props.load(data)
       */
        
    console.log('sbv--fligh_space_key id ****+++++++++++++++++++++++++++ we will use _doc as the space has details of sohourn as single flat indxex:')
    
    
      
   
			
			
	

	}
    /*
    

  
    getAppDetails(paramQSpaceId){
        // Previou step of wizard has alrady put the state  in Review get from thatfrom props and pas fpdData
       let newFormData= {
        "addressId": 6,
        "customerId": 6,
        "name": "alen beta",
        "fname": "alen",
        "lname": "beta",
        "phone": "5121231234",
        "email": "alen11@br.com",
        "login": "alenb",
        "password": null,
        "otherDetails": "need pickup",
        "city": "san jose",
        "state": "ca",
        "country": "usa",
        "address": null,
        "zipcode": "95123",
        "isdcode": "1",
        "addressType": "B",
        "createdDate": null,
        "modifiedDate": null,
        "createdBy": null,
        "modifiedBy": null
    }
        this.props.load(newFormData)
       
        
     }
     */
 loadGene(e){
        console.log(e)
    }

    dcountryChange(e){

        console.log(e)
        console.log('gene name:' +this.props.dcountry)

        let o = _.findWhere(dcountries,{value:e.target.value})
        console.log(o)
        this.props.load({
            id:o.value,
             dcountry:o.name
        })

    }
    
    ddChange(e){
        
        console.log(e)
        console.log('gene name:' +this.props.gene)

        let o = _.findWhere(genes,{value:e.target.value})
        console.log(o)
        this.props.load({
            id:o.value,
             gene:o.name
        })
        //load geneBus Componnet initialValues and form will reinitalize

    }
    /*svj30 start*/
    svpdcCurryCom = (param1, ctxThis) => (o) => {
        let STARTDATE_ITN_TZAWARE_EST = "2025-11-25"
        console.log("*******svj22****curry** START")
        console.log(param1)

        console.log(ctxThis)

        console.log(o)
        const { input: { onChange, value } } = o
        console.log("*******svj22****redux vaalue**")
        console.log(value)

        let vob = null
        let vob_date = null
        let mo_ss = moment(STARTDATE_ITN_TZAWARE_EST, 'YYYY-MM-DD');
        let mofval = null
        let mofmom = null
        if(value && _.isString(value) && value.length <=1){
            vob_date = moment()
        } else if(value && _.isString(value) && value.length > 1){
            let d_s = value
            vob_date = moment(d_s)
            mofmom  = moment(d_s)
        } else if(value && _.isObject(value)){
            vob = value
            vob_date = value._d
            mofmom  = moment(vob_date)
        }else if (value == null){
            mofval = mo_ss
            mofmom = moment()

        }else{
            console.log('svJ30 ***bad valeue CAUSE ISSUE***')
            console.log(value)
             vob = value
             vob_date = value._d
             mofmom  = moment(vob_date)
        }
        console.log(vob_date)
        

        
        /*
        if (value != null) {
            mofval = moment(vob_date)
            let mofval_str = mofval.format('YYYY-MM-DD')

            console.log("*******svj22****mofval_stre**")

            console.log(mofval_str)
            this.setState({'svdob':mofval_str})



           // let mom_value = !value ? mo_ss : mofval_str
           mofval = !value ? mo_ss : mofval_str
           mofmom = moment(mofval)
        } else {
            mofval = mo_ss
            mofmom = moment()
        }
        */

        let TIME_NO = false



        return (<DatePicker showTime={TIME_NO} onChange={onChange} value={mofmom} />)


    }
    renderAd({ input: { onChange, value }, showTime }){
        let param1 =  "1974-01-14"
        console.log('svj30*** FPD  value start')
        console.log(value)
        console.log('svj30*** FPD  value start')


        return (

            <Field 
            id="dateOfBirth"
            name="dateOfBirth"
                className="form-control"
                component={this.svpdcCurryCom(param1, this)}
            />
        )


    }
    /*svj30 end*/
    render(){
        console.log('sv... SVCDnaStepFormBus')
        const { handleSubmit, pristine, error,reset, submitting } = this.props
        const {member, index}= this.props
        const { load, initialValues } = this.props
        const {custProfile} = this.props
        const {renderAd } = this
         //const { initialValues,load, handleSubmit,loadGeneTemplate,  pristine, reset, submitting, submit, startSubmit } = this.props 
       //we are copying all members from initialValues and senfint to props
       /* const {initialValues} = this.props
       

        */
        const {  isdcode, email} = this.props
        const {countryTypes, isdcodeTypes, genderTypes,stateTypes} = this.props.my_data_geo
        console.log( isdcode)
        console.log( email)
        console.log( isdcode)
        console.log(initialValues)
       
       // const { id, gene, email} = initialValues

        const me = this 
        //me.gene = gene

        console.log(this.props)

        return (
            <div>
             
            <form  onSubmit={handleSubmit}>
            <div className="rev-row">
             <div className="card card--raised with-shadow">
                <p className="right-sd-content"> <text> Enter Details Now </text></p>

                    <div className="form-group">
                            <label htmlFor="id"> ID</label>
                            
                                <Field
                            
                                id="id"
                                    name="id"
                                    type="text"
                                    placeholder="id"
                                    component="input"
                                    className="form-control"
                                />
                            

                        </div>
                    <div className="form-group">
                            <label htmlFor="fname"> First Name <span class="svr-required">*</span></label>
                            
                                <Field
                            
                                    id="fname"
                                    name="fname"
                                    type="text"
                                    placeholder="John"
                                    component={renderField}
                                    className="form-control"
                                />
                        </div>
                        <div className="form-group">
                            <label htmlFor="lname"> Last Name <span class="svr-required">*</span></label>
                            <Field
                                    id="lname"
                                    name="lname"
                                    type="text"
                                    placeholder="Glen"
                                    component={renderField}
                                    className="form-control"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="email"> Email Address<span class="svr-required">*</span></label>
                            <Field
                                    id="email"
                                    name="email"
                                    type="text"
                                    placeholder="john123@yahoo.com"
                                    component="input"
                                    className="form-control"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="address"> Address <span class="svr-required">*</span></label>
                            <Field
                                    id="address"
                                    name="address"
                                    type="text"
                                    placeholder="790 J St, Lincoln"
                                    component={renderField}
                                    className="form-control"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="city"> City <span class="svr-required">*</span></label>
                            <Field
                                    id="city"
                                    name="city"
                                    type="text"
                                    placeholder="Lincoln"
                                    component={renderField}
                                    className="form-control"
                            />
                        </div>
                        
                        <div className="form-group">
                                            <label htmlFor="state"> STATE(2 letter)<span class="svr-required">*</span></label>
                                            <Field
                                                    id="state"
                                                    name="state"
                                                    type="text"
                                                    placeholder="ca"
                                                    component="input"
                                                    className="form-control"
                                            />
                                        </div>
                        <div className="form-group">
                                                <label htmlFor="country" > Country<span class="svr-required">*</span></label>
                                                <Field  component="select" id="country"   name="country"  className="form-control" >
                                                
                                                    <option value="">Select Country A3</option>
                                                    {
                                        
                                                
                                        countryTypes.map(  (o, idx)=>(  <option value={o.value} key={o.name}>{o.name}</option>)
                                                    
                                                    
                                                    
                                                
                                                )}
        
                                                    </Field>
                        </div>
                        <div className="form-group">
                            <label htmlFor="gene"> Zip Code</label>
                            <Field
                                    id="zip"
                                    name="zip"
                                    type="text"
                                    placeholder="95648"
                                    component={renderField}
                                    className="form-control"
                            />
                        </div>
                        {/* 
                        <div class="form-group">
                        
                        <label htmlFor="dcountry">Country </label>
                        <Field id="dcountry"  name="dcountry" onChange={me.dcountryChange} component="select">

                            <option  value="">Select Country</option>
                            {
                                dcountries.map ((o, idx)=>{

                                    return ( <option  value={o.value}>{o.name}</option>)
                                })
                            }

                        </Field>

                        </div>
                        */}
                        <div className="form-group">
                                                <label htmlFor="isdcode" > ISD Code<span class="svr-required">*</span></label>
                                                <Field  component="select" id="isdcode"   name="isdcode"  className="form-control" >
                                                
                                                    <option value="">Select PhoneCalling /ISD Code</option>
                                                    {
                                        
                                                
                                        isdcodeTypes.map(  (o, idx)=>(  <option value={o.value} key={o.name}>{o.name}</option>)
                                                    
                                                    
                                                    
                                                
                                                )}
        
                                                    </Field>
                                        </div>
                        {/* 
                        
                        <div className="form-group">
                            <label htmlFor="isdcode"> ISD Code</label>
                            <Field
                                    id="isdcode"
                                    name="isdcode"
                                    type="text"
                                    placeholder="+1"
                                    component="input"
                                    className="form-control"
                            />
                        </div>
                        */}
                        
                        <div className="form-group">
                            <label htmlFor="phone"> Phone<span class="svr-required">*</span></label>
                            <Field
                                    id="phone"
                                    name="phone"
                                    type="text"
                                    placeholder="916-645-6360"
                                    component={renderField}
                                    className="form-control"
                            />
                        </div>
                    
               

                {/*   
                <div className="form-group">
                   
                    <label className="svradio-item-label-bl">
                        <Field name="bookingAgentType" component="input" type="radio" value="self" />{' '}
                        Self
                    </label>
                    <label className="svradio-item-label-bl">
                        <Field name="bookingAgentType" component="input" type="radio" value="others" />{' '}
                        Others
                    </label>
    
                </div>
                */}
                {/* 
                <div className="form-group">
                    <label htmlFor="bookingAgentType">Who are you booking for?</label>

                        <Field
                        name="bookingAgentType"
                        component={renderSelectList}
                        data={['Self', 'Others']}
                        />
                </div>
                */}
               
                {/*  
                <div className="form-group">
                     <label htmlFor="specialRequests"> Special Requests</label>
                    <Field
                            id="specialRequests"
                            name="specialRequests"
                            type="text"
                            placeholder="Wheel chair and Senior Citizen"
                            component="textarea"
                            className="form-control"
                    />
                </div>
                <div className="form-group">
                     <label htmlFor="card">  Credit Card Number</label>
                    <Field
                            id="card"
                            name="card"
                            type="text"
                            placeholder="1234-1234--1234--1234"
                            component={renderField}
                            className="form-control"
                    />
                </div>
                <div className="form-group">
                     <label htmlFor="gene">  Card CVV/CVV2</label>
                    <Field
                            id="cvv"
                            name="cvv"
                            type="text"
                            placeholder="123"
                            component={renderField}
                            className="form-control"
                    />
                </div>
                <div className="form-group">
                     <label htmlFor="mmexp">  Card Expiration Date Month</label>
                    <Field
                            id="mmexp"
                            name="mmexp"
                            type="text"
                            placeholder="02"
                            component={renderField}
                            className="form-control"
                    />
                </div>
                <div className="form-group">
                     <label htmlFor="yyyyexp">  Card Expiration Date Year</label>
                    <Field
                            id="yyyyexp"
                            name="yyyyexp"
                            type="text"
                            placeholder="2028"
                            component={renderField}
                            className="form-control"
                    />
                </div>
                
                <div class="form-group">
                  
                  <label htmlFor="gene">BusSlot </label>
                  <Field id="gene"  name="gene" onChange={me.ddChange} component="select">

                    <option  value="">Select DNA</option>
                    {
                        genes.map ((o, idx)=>{

                            return ( <option  value={o.value}>{o.name}</option>)
                        })
                    }

                  </Field>

                </div>

                */}

               <div>
            </div>
            </div>
         </div>
         <div className="rev-row">
                    <div className="card card--raised with-shadow">
                        <p className="right-sd-content"> <text> Mandatory Booking Information </text></p>
                        <div className="form-group">
                                                <label htmlFor="gender" > Gender<span class="svr-required">*</span></label>
                                                <Field  component="select" id="gender"   name="gender"  className="form-control" >
                                                
                                                    <option value="">Select Gender Type</option>
                                                    {
                                        
                                                
                                        genderTypes.map(  (o, idx)=>(  <option value={o.value} key={o.name}>{o.name}</option>)
                                                    
                                                    
                                                    
                                                
                                                )}
        
                                                    </Field>
                        </div>
                        {/*  
                        <div className="form-group">
                            <label htmlFor="traveType">Gender</label>

                                <Field
                                name="traveType"
                                component={renderGenderSelectList}
                                data={['MALE', 'FEMALE']}
                                />
                        </div>
                        */}
                        {/* 
                    <div className="form-group">
                            <label htmlFor="dateOfBirth"> SVJ30 Date Of Birth</label>
                            <SVPDDInputEp member={member}   placeholder="1913-01-13" /> 
                           
                        </div>
                    
                     <div className="form-group">
                            <label htmlFor="dateOfBirth"> Date Of Birth</label>
                        
                         <Field
                                    id="dateOfBirth"
                                    name="dateOfBirth"
                                    type="text"
                                    placeholder="1982-01-15"
                                    component={renderField}
                                    className="form-control"
                            />
                    </div>
                        */}
                        <div className="form-group">
                            <label htmlFor="dateOfBirth">Date Of Birth<span class="svr-required">*</span></label>
                            <Field
                                    id="dateOfBirth"
                                    name="dateOfBirth"
                                    type="text"
                                    placeholder="1995-01-15"
                                    component={renderAd}
                                    className="form-control"
                            />
                           
                        </div>
                    </div>
        </div>
            <div className="rev-row">
                    <div className="card card--raised with-shadow">
                        <p className="right-sd-content"> <text> Additional Travel Information </text></p>
                        <div className="form-group">
                            <label htmlFor="bookingAgentType">Who are you booking for?</label>

                                <Field
                                name="bookingAgentType"
                                component={renderBookingAgentType}
                                data={['selfTravel', 'others']}
                                />
                        </div>
                        <div>
                        <label htmlFor="radiogroupba">RG</label>
                        <Radio.Group name="radiogroupba" defaultValue={1}>
                            <Radio value={1}>A</Radio>
                            <Radio value={2}>B</Radio>
                            <Radio value={3}>C</Radio>
                            <Radio value={4}>D</Radio>
                         </Radio.Group>
                        </div>
                        <div className="form-group">
                            <label htmlFor="traveType">Business Travel ?</label>

                                <Field
                                name="traveType"
                                component={renderTravelSelectList}
                                data={['Business', 'Personal']}
                                />
                        </div>
                    </div>
            </div>
            
            <div className="rev-row">
              <div className="card card--raised with-shadow">
                 <p className="right-sd-content"> <text> Guest Details </text></p>

                 <div className="form-group">
                     <label htmlFor="gname"> Full Guest Name</label>
                    <Field
                            id="gname"
                            name="gname"
                            type="text"
                            placeholder="jenny"
                            component="input"
                            className="form-control"
                    />
                </div>
                <div className="form-group">
                     <label htmlFor="gemail">  Guest Email</label>
                    <Field
                            id="gemail"
                            name="gemail"
                            type="text"
                            placeholder="jenny@yahoo.com"
                            component="input"
                            className="form-control"
                    />
                </div>
            </div>
        
        <button type="submit" className="btn btn-success" disabled={pristine || error || submitting}>
               Next -  Payment Details
        </button>   
        <button type="button" className="btn btn-success" onClick={this.props.previousPage}>
          Previous - Space Details
        </button>
        {/*  
        <button type="button" onClick={() => load(data)}>
          Load Account
        </button>
        */}
        { this.fsHome(custProfile)}
       
        
        </div>
               

            
            </form>
         </div>
        )
    }

}

const fpdForm = reduxForm({

    form:SVFPDFORM,
    validate:validate,
   // asyncValidate: asyncValidate,
    warn:warn,
    //onSubmit:svsubmit,
    onChange:svChange,
    enableReinitialize:true,
    keepDirtyOnReinitialize:true

})(FlyPaymentDetailFormBus)

const selector = formValueSelector(SVFPDFORM)



let FlyPaymentDetailFormBusCom =connect((state=>{
    //we are not using key nmae intiailValues rathre returning flat content ky/valu as fpdData
    //reducForm provideis built in load - we have tp provide our action here  then our form component can call load from props
    //we cannot mofifiy initial Valy=ues or statehere only in reducers
//we have action loadAddressData from reviewaction that modiefied fpdData in TaskReducer. the address data is stored in this form. we will add card data also in fpdData
    let plucked = state.movies
    console.log('sv***FlyPaymentDetails taskreducers')
    console.log(plucked)
    let custProfile = state.flyreviewView.custProfile
    let my_data_flyaddress = state.flyreviewView.my_data_flyaddress
    let my_data_geo = state.flyreviewView.my_data_geo
    let my_data_card = state.flyreviewView.my_data_card
    let o = {initialValues:plucked.fpdData ,"my_data_geo":my_data_geo ,"my_data_card":my_data_card,"my_data_flyaddress":my_data_flyaddress, "custProfile":custProfile}
    selector(state, 'id')
    console.log('sv OCT5 Payment Address info*********PAyment Address OCT5')
    console.log(o)
     
    //return plucked.fpdData
    return o
}),{
    //load:loadPdMyReservatiionsAddressAction,
    load:loadFlyAddressDataDB,
    
    startSubmit:startSubmit
   
   // loadGeneTemplate:loadGeneTemplate

    
})(fpdForm)





export default FlyPaymentDetailFormBusCom